module.exports = __webpack_public_path__ + "static/img/device_s3_max.0dbc230c.png";